import { useUserService } from '@/modules/User/services/UserService';

const AuthService = useUserService();

const createRouteMeta = {
  mainClasses: 'App-main__fullscreen',
  hideAside: true,
  hideHeader: true,
  hideFooter: true,
};

const routes = [
  {
    path: '/brands',
    name: 'brands',
    component: () => import(
      /* webpackChunkName: "ClusterModule" */
      '@/modules/Clusters/ClustersModule.vue'
    ),
    meta: {
      mainClasses: 'App-main__withall',
      clusterType: 'Brand',
      hideAside: false,
      hideFooter: true,
      requiresAuth: true,
      requiresAccountSelected: true,
      requiresActiveProperties: true,
      accountSettingsPage: true,
      requiresValidUser: AuthService.isValidUser,
    },
    children: [
      {
        path: '',
        name: 'brands-list',
        component: () => import(
          /* webpackChunkName: "ClustersModule" */
          '@/modules/Clusters/views/ClusterList.vue'
        ),
      },
      {
        path: 'create',
        name: 'create-brand',
        component: () => import(
          /* webpackChunkName: "ClustersModule" */
          '@/modules/Clusters/views/CreateCluster/CreateCluster.vue'
        ),
        meta: createRouteMeta,
      },
      {
        path: ':id',
        name: 'brand',
        component: () => import(
          /* webpackChunkName: "ClustersModule" */
          '@/modules/Clusters/views/ClusterDetails.vue'
        ),
      },
    ],
  },
  {
    path: '/clusters',
    name: 'clusters',
    component: () => import(
      /* webpackChunkName: "ClustersModule" */
      '@/modules/Clusters/ClustersModule.vue'
    ),
    meta: {
      mainClasses: 'App-main__withall',
      hideAside: false,
      hideFooter: true,
      requiresAuth: true,
      requiresAccountSelected: true,
      requiresActiveProperties: true,
      accountSettingsPage: true,
      clusterType: 'Cluster',
      requiresValidUser: AuthService.isValidUser,
    },
    children: [
      {
        path: '',
        name: 'clusters-list',
        component: () => import(
          /* webpackChunkName: "ClustersModule" */
          '@/modules/Clusters/views/ClusterList.vue'
        ),
      },
      {
        path: 'create',
        name: 'create-cluster',
        component: () => import(
          /* webpackChunkName: "ClustersModule" */
          '@/modules/Clusters/views/CreateCluster/CreateCluster.vue'
        ),
        meta: createRouteMeta,
      },
      {
        path: ':id',
        name: 'cluster',
        component: () => import(
          /* webpackChunkName: "ClustersModule" */
          '@/modules/Clusters/views/ClusterDetails.vue'
        ),
      },
    ],
  },
];

export default routes;
